export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token") || null;
};
